export default "QuestBox åbnede i juli 2016.";